import React from 'react';
import { LOGO_URL, PHONE_DISPLAY, PHONE_HREF, SALES_EMAIL, navLinks } from '../data/homepage';
export function SiteFooter() {
  return <footer className="on-dark bg-ink text-white" data-id="element-135" data-mp="3r8rikunn8i0h">
      <div className="mx-auto max-w-[1280px] px-5 py-14 md:px-8" data-id="element-136" data-mp="3mh13ychob839">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between" data-id="element-137" data-mp="3mfgc4umqu393">
          <div data-id="element-138" data-mp="3hgdg1zoqr7d9">
            <img src={LOGO_URL} alt="WebsiteForge" className="h-11 w-auto" width={196} height={44} data-id="element-139" data-mp="3dgutz0l6oq8u" />
            <p className="mt-4 text-[16px] font-semibold text-white/80" data-id="element-140" data-mp="38hrndbpk2byr">
              Websites, marketing, and technology. Handled.
            </p>
          </div>
          <div className="grid gap-8 sm:grid-cols-2 sm:gap-16" data-id="element-141" data-mp="33j6vq0odd0lx">
            <nav aria-label="Footer" data-id="element-142" data-mp="2ykdlch4dpppz">
              <ul className="space-y-3" data-id="element-143" data-mp="2yleu2exxa04j">
                {[...navLinks, {
                label: "Let's talk",
                href: '#contact'
              }].map(link => <li key={link.href} data-id="element-144" data-mp="ws7fj7q4vmjp">
                    <a href={link.href} className="text-[15px] font-semibold text-white/80 hover:text-white" data-id="element-145" data-mp="wtilne71x6dz">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>
            <ul className="space-y-3" data-id="element-146" data-mp="1anlpfqkvbl27">
              <li data-id="element-147" data-mp="vth6y7jz617h">
                <a href={PHONE_HREF} className="text-[15px] font-semibold text-white/80 hover:text-white" data-id="element-148" data-mp="vtz73f9rczko">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li data-id="element-149" data-mp="1oh37f6xwopq4">
                <a href={`mailto:${SALES_EMAIL}`} className="text-[15px] font-semibold text-white/80 hover:text-white" data-id="element-150" data-mp="1oio535fioos7">
                  {SALES_EMAIL}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p className="mt-12 border-t border-ink-line pt-6 text-[13px] text-white/60" data-id="element-151" data-mp="1eppc7bczmc2s">© 2026 WebsiteForge</p>
      </div>
    </footer>;
}